<section class="position-relative">
  <div class="container-fluid w-limit">
    <div class="row justify-content-center text-center align-items-center">
      <div class="col-12">
        <h1 class="fs-4 text-danger mt-2">Emisión de tus seguros</h1>
        <p class="text-body-tertiary mb-4 fs-6 fw-semibold small mx-auto" style="max-width: 400px;">Completa la
          información personal de los asegurados antes de procesar la emisión de tu seguro de personas</p>
        <h2 class="fs-5 fw-normal">Información de las personas aseguradas</h2>
      </div>
    </div>
  </div>
</section>
@if (activeModal) {
<div aria-modal="true" class="modal fade show d-block modal-insurace-option-checkout" role="dialog" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded-4">
      <div class="modal-header border m-2 p-2 pe-3 rounded-3">
        <div class="d-flex align-items-center gap-2">
          <app-icon [name]="getSafeIconName(modalIcon)" [size]="28" [strokeWidth]="1.75" color="#ce343c"></app-icon>
          <h5 class="modal-title m-0 text-capitalize">{{ modalTitle }}</h5>
        </div>
        <button (click)="closeModal()" aria-label="Cerrar" class="btn-close" type="button"></button>
      </div>
      <div class="modal-body p-2">
        @if (modalDescription) {<h3 class="text-body-secondary fs-6 fw-bold">{{ modalDescription }}</h3>}
        @switch (activeModal) {
        @case ('info-person') {
        <app-checkout-insured-form [documentMask]="documentMask" [form]="personFg" [passportExpiryMax]="passportExpiryMax"
          [readonlyBirthDate]="modalTitle.toLowerCase().includes('asegurado principal') || modalTitle.toLowerCase().includes('cónyugue') || modalTitle.toLowerCase().includes('hijo') || modalTitle.toLowerCase().includes('datos de ')"
          [readonlyGender]="modalTitle.toLowerCase().includes('asegurado principal') || modalTitle.toLowerCase().includes('cónyugue') || modalTitle.toLowerCase().includes('hijo') || modalTitle.toLowerCase().includes('datos de ')"></app-checkout-insured-form>
        }
        @case ('questions') {
        <app-checkout-questions (fileSelected)="onFileSelected($event)" (fileRemoved)="onFileRemoved($event)"
          [activeGroup]="activeQuestionGroup" [form]="questionsFg" [uploadStates]="uploadStates"
          (retryUpload)="startUpload($event)" [fileSelections]="fileSelections"></app-checkout-questions>
        }
        @case ('upload-documents') {
        <app-checkout-upload-documents [uploadedFiles]="uploadedDocuments"
          (filesChanged)="onDocumentFilesChanged($event)"></app-checkout-upload-documents>
        }
        @case ('payment') {
        <app-checkout-payment [(paymentAmountOption)]="paymentAmountOption" [(paymentOtherAmount)]="paymentOtherAmount"
          [(termsAccepted)]="termsAccepted" [isPaymentAmountInvalid]="isPaymentAmountInvalid"
          [quoteCurrency]="quoteCurrency" [summary]="summary" [minimumPaymentAmount]="minimumPaymentAmount">
        </app-checkout-payment>
        }
        }
      </div>
      @if (activeModal !== 'payment') {
      <div class="modal-footer border-0 pt-0">
        <button (click)="closeModal()" class="btn btn-outline-secondary rounded-pill" type="button">Cerrar</button>
        @if (activeModal !== 'upload-documents') {
        <button (click)="onContinue()" class="btn btn-danger rounded-pill" type="button"
          [disabled]="activeModal === 'questions' && hasUploadsInProgress">
          @if (activeModal === 'questions' && hasUploadsInProgress) {
          Subiendo archivo...
          } @else {
          Continuar
          }
        </button>
        } @else {
        <button (click)="closeModal()" class="btn btn-danger rounded-pill" type="button">Cargar documentos</button>
        }
      </div>
      }
      @if (activeModal === 'payment') {
      <div class="modal-footer border-0 pt-0">
        <button (click)="closeModal()" class="btn btn-outline-danger rounded-pill" type="button"
          [disabled]="isPaymentLoading">Cancelar</button>
        <button (click)="onPayAndIssue()" [disabled]="!termsAccepted || isPaymentAmountInvalid || isPaymentLoading"
          class="btn btn-danger rounded-pill d-flex align-items-center gap-2" type="button">
          @if (isPaymentLoading) {
          <div class="spinner-border spinner-border-sm text-light" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          }
          Pagar y emitir seguro
        </button>
      </div>
      }
    </div>
  </div>
</div>
<div (click)="closeModal()" class="modal-backdrop fade show"></div>
}
@for (insuranceTypeDetails of currentQuote?.details; track $index){
<app-checkout-detail (countryChange)="onCountryChange(insuranceTypeDetails.id!, $any($event))"
  (openModalRequest)="openModal($event.type, $event.title, $event.icon, $event.description, $event.detailId)"
  (openOtherInsuredRequest)="openOtherInsured($event.detailId, $event.insuredPersonId, $event.title, $event.description)"
  (openQuestionsForGroupRequest)="openQuestionsForGroup($event)"
  (stateChange)="onStateChange(insuranceTypeDetails.id!, $any($event))"
  (useAsPrimaryForAllChange)="onUseAsPrimaryForAllChange(insuranceTypeDetails.id!, $event)" [countries]="countries"
  [detail]="insuranceTypeDetails" [filteredZipFullDescs]="getFilteredZipFullDescs(insuranceTypeDetails.id!)"
  [filteredStates]="getFilteredStates(insuranceTypeDetails.id!)" [form]="getDetailForm(insuranceTypeDetails.id!)"
  [hideSyncOption]="useAsPrimaryForAllDetailId != null && useAsPrimaryForAllDetailId !== insuranceTypeDetails.id!"
  [netPremium]="detailNetPremium(insuranceTypeDetails.id!)"
  [showContact]="useAsPrimaryForAllDetailId !== insuranceTypeDetails.id! && !useAsPrimaryForAllDetailId"
  [states]="states" [totalDetails]="currentQuote?.details?.length ?? 1"
  [useAsPrimaryForAll]="useAsPrimaryForAllDetailId === insuranceTypeDetails.id!" [isSummaryLoading]="isSummaryLoading">
</app-checkout-detail>
}

<section>
  <div class="container-fluid w-limit py-2">
    <div class="row g-4 justify-content-center">
      <div class="col-12 col-md-8">
        <div class="card card-policy-summary border rounded-3 border-0 shadow">
          <div class="card-body p-4">
            <div class="d-flex flex-column gap-3">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <app-icon name="circle-user-round" [size]="24" [strokeWidth]="1.75" color="#ce343c"></app-icon>
                  <h3 class="m-0 fs-5 fw-semibold text-start">Datos del Contratante</h3>
                </div>
                <!-- Toggle visible if we have exactly 1 detail OR if multiple products share the same primary insured -->
                @if ((currentQuote?.details?.length || 0) === 1 || useAsPrimaryForAllDetailId != null) {
                <div class="form-check form-switch d-flex align-items-center gap-2 m-0">
                  <input (change)="onContratanteNotInsuredChange($any($event.target).checked)"
                    [checked]="isContratanteNotInsured" class="form-check-input focus-ring focus-ring-success"
                    id="check-mark-other-contratante-global" role="switch" type="checkbox">
                  <label class="form-check-label fw-normal text-muted small"
                    for="check-mark-other-contratante-global">El contratante no es el asegurado principal</label>
                </div>
                }
              </div>

              @if (isContratanteNotInsured) {
              <div [formGroup]="requestedByFg" class="form-bloque-requested-by mt-2">
                <div class="text-secondary mb-3 small">
                  Complete los datos de la persona o empresa que figura como contratante de la póliza.
                </div>
                <div class="form-items d-flex flex-column gap-2">
                  <div class="row g-2">
                    <div class="col-12 col-md-6">
                      <div class="form-floating">
                        <select class="form-select focus-ring focus-ring-light" id="requestedByPersoneria"
                          aria-label="Personería" formControlName="personeria"
                          (change)="onContractorPersoneriaChange()">
                          <option [ngValue]="Personeria.Fisica">Física</option>
                          <option [ngValue]="Personeria.Moral">Moral</option>
                        </select>
                        <label for="requestedByPersoneria">Personería</label>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-floating">
                        <select
                          [class.is-invalid]="requestedByFg.get('relationship')?.touched && requestedByFg.get('relationship')?.invalid"
                          aria-label="Relación con el asegurado" class="form-select focus-ring focus-ring-light"
                          formControlName="relationship" id="requestedByRelationship">
                          <option disabled value="">Seleccione</option>
                          <option value="Conyuge">Cónyuge</option>
                          <option value="Padre">Padre</option>
                          <option value="Madre">Madre</option>
                          <option value="Hijo">Hijo/a</option>
                          <option value="Hermano">Hermano/a</option>
                          <option value="Otro">Otro</option>
                        </select>
                        <label for="requestedByRelationship">Relación con el asegurado</label>
                        <div class="invalid-feedback">Requerido</div>
                      </div>
                    </div>
                  </div>
                  <div class="row g-2">
                    <div class="col-12 col-md-6">
                      <div class="form-floating">
                        @if (contractorIsMoral) {
                        <select class="form-select focus-ring focus-ring-light bg-light" id="requestedByDocumentType"
                          aria-label="Tipo de documento" formControlName="documentType" [attr.disabled]="true">
                          <option [ngValue]="'RNC'">RNC</option>
                        </select>
                        } @else {
                        <select class="form-select focus-ring focus-ring-light" id="requestedByDocumentType"
                          aria-label="Tipo de documento" formControlName="documentType">
                          <option [ngValue]="'IdCard'">Cédula</option>
                          <option [ngValue]="'Passport'">Pasaporte</option>
                        </select>
                        }
                        <label for="requestedByDocumentType">Tipo de documento</label>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-floating">
                        <input [mask]="contractorDocMask"
                          [class.is-invalid]="requestedByFg.get('documentNumber')?.touched && requestedByFg.get('documentNumber')?.invalid"
                          class="form-control focus-ring focus-ring-light" formControlName="documentNumber"
                          id="requestedByDocumentNumber" placeholder=" " type="text">
                        <label for="requestedByDocumentNumber">{{ contractorDocLabel }}</label>
                        <div class="invalid-feedback">
                          @if (requestedByFg.get('documentNumber')?.hasError('passportLength')) {
                          El pasaporte debe tener entre 5 y 12 caracteres.
                          } @else {
                          Requerido
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row g-2">
                    <div [class]="contractorIsMoral ? 'col-12' : 'col-12 col-md-6'">
                      <div class="form-floating">
                        <input
                          [class.is-invalid]="requestedByFg.get('name')?.touched && requestedByFg.get('name')?.invalid"
                          class="form-control focus-ring focus-ring-light" formControlName="name" id="requestedByName"
                          placeholder=" " type="text" maxlength="40">
                        <label for="requestedByName">{{ contractorNameLabel }}</label>
                        <div class="invalid-feedback">Requerido</div>
                      </div>
                    </div>
                    @if (!contractorIsMoral) {
                    <div class="col-12 col-md-6">
                      <div class="form-floating">
                        <input
                          [class.is-invalid]="requestedByFg.get('lastName')?.touched && requestedByFg.get('lastName')?.invalid"
                          class="form-control focus-ring focus-ring-light" formControlName="lastName"
                          id="requestedByLastName" placeholder=" " type="text" maxlength="40">
                        <label for="requestedByLastName">Apellidos</label>
                        <div class="invalid-feedback">Requerido</div>
                      </div>
                    </div>
                    }
                  </div>
                  <div class="row g-2">
                    <div class="col-12">
                      <div class="form-floating">
                        <input
                          [class.is-invalid]="requestedByFg.get('street')?.touched && requestedByFg.get('street')?.invalid"
                          class="form-control focus-ring focus-ring-light" formControlName="street"
                          id="requestedByStreet" placeholder=" " type="text" maxlength="150">
                        <label for="requestedByStreet">Calle y número</label>
                        <div class="invalid-feedback">Requerido</div>
                      </div>
                    </div>
                  </div>
                  <div class="row g-2">
                    <div class="col-12 col-md-6">
                      <div class="form-floating">
                        <select class="form-select focus-ring focus-ring-light bg-light" id="requestedByCountry"
                          formControlName="countryCode" [attr.disabled]="true">
                          <option [ngValue]="null" disabled selected>Seleccione</option>
                          @for (c of countries; track c?.countryCode) {
                          <option [ngValue]="c.countryCode">{{ c.countryName }}</option>
                          }
                        </select>
                        <label for="requestedByCountry">País</label>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <app-searchable-dropdown id="requestedByState" [items]="states" bindLabel="stateName"
                        bindValue="stateCode" [value]="requestedByFg.get('stateCode')?.value"
                        [invalid]="!!(requestedByFg.get('stateCode')?.touched && requestedByFg.get('stateCode')?.invalid)"
                        placeholder="Buscar estado / provincia..." label="Estado / Provincia"
                        (valueChange)="requestedByFg.get('stateCode')?.setValue($event); onRequestedByStateChange($event)"
                        (blurred)="requestedByFg.get('stateCode')?.markAsTouched()">
                      </app-searchable-dropdown>
                      <div class="invalid-feedback d-block"
                        [class.d-none]="!(requestedByFg.get('stateCode')?.touched && requestedByFg.get('stateCode')?.invalid)">
                        Requerido
                      </div>
                    </div>
                  </div>
                  <div class="row g-2">
                    <div class="col-12 col-md-6">
                      <app-searchable-dropdown id="requestedByZipFullDesc" [items]="requestedByZipFullDescs"
                        bindLabel="zipName" bindValue="zipCode" [value]="requestedByFg.get('zipFullDescCode')?.value"
                        [disabled]="!requestedByFg.get('stateCode')?.value"
                        [invalid]="!!(requestedByFg.get('zipFullDescCode')?.touched && requestedByFg.get('zipFullDescCode')?.invalid)"
                        label="Sector o Paraje" placeholder="Buscar sector o paraje..."
                        (valueChange)="requestedByFg.get('zipFullDescCode')?.setValue($event)"
                        (blurred)="requestedByFg.get('zipFullDescCode')?.markAsTouched()">
                      </app-searchable-dropdown>

                      <div class="invalid-feedback d-block"
                        [class.d-none]="!(requestedByFg.get('zipFullDescCode')?.touched && requestedByFg.get('zipFullDescCode')?.invalid)">
                        Requerido
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              }

              <!-- Tipo de comprobante: always visible -->
              <div class="row g-2 mt-2">
                <div class="col-12">
                  <div class="form-floating">
                    <select class="form-select focus-ring focus-ring-light" id="contratanteTipoComprobante"
                      aria-label="Tipo de comprobante" [formControl]="$any(requestedByFg.get('tipoComprobante'))"
                      [class.is-invalid]="requestedByFg.get('tipoComprobante')?.touched && requestedByFg.get('tipoComprobante')?.invalid">
                      <option [ngValue]="null" disabled selected>Selecciona una opción</option>
                      <option [ngValue]="32">Factura de consumo electrónica</option>
                      <option [ngValue]="31">Generan Créditos y/o Sustentan Costos y Gastos</option>
                    </select>
                    <label for="contratanteTipoComprobante">Tipo de comprobante</label>
                    <div class="invalid-feedback">Debe seleccionar un tipo de comprobante.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

@if (useAsPrimaryForAllDetailId) {
<div class="container-fluid w-limit py-4">
  <div class="row g-4 justify-content-center">
    <div class="col-12 col-md-8">
      <app-checkout-contact (countryChange)="onCountryChange(useAsPrimaryForAllDetailId, $any($event))"
        (stateChange)="onStateChange(useAsPrimaryForAllDetailId, $any($event))" [countries]="countries"
        [filteredZipFullDescs]="getFilteredZipFullDescs(useAsPrimaryForAllDetailId)"
        [filteredStates]="getFilteredStates(useAsPrimaryForAllDetailId)"
        [form]="getDetailForm(useAsPrimaryForAllDetailId)"></app-checkout-contact>
    </div>
  </div>
</div>
}
<footer class="border-bottom border-5">
  <div class="container-fluid" style="max-width: 790px;">
    <div class="row justify-content-between g-2 border-top py-4">
      <div class="col-auto">
        <button (click)="onBack()" class="btn btn-outline-secondary rounded-pill" type="button">Retroceder</button>
      </div>
      <div class="col-auto">
        <button (click)="onPayNow()" class="btn btn-primary btn-pagar btn-modal-form-upload-documents rounded-pill"
          type="button">Pagar ahora</button>
      </div>
    </div>
  </div>
</footer>